var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "BaseDialog" }, [
    _c("div", { staticClass: "BaseDialog_HeaderBtn" }, [
      !_vm.disableCloseButton
        ? _c(
            "button",
            {
              staticClass: "BaseDialog_CloseBtn",
              attrs: { "data-test": "closeBtn" },
              on: { click: _vm.close }
            },
            [_c("FontAwesomeIcon", { attrs: { icon: "close", size: "1x" } })],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { ref: "wrapper", staticClass: "BaseDialog_Wrapper" }, [
      _vm.$slots.header
        ? _c(
            "div",
            {
              staticClass: "BaseDialog_Header",
              attrs: { "data-test": "headerSlot" }
            },
            [_vm._t("header")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.main
        ? _c(
            "div",
            {
              staticClass: "BaseDialog_Main",
              class: { _overflowScroll: _vm.overflowScroll },
              attrs: { "data-test": "mainSlot" }
            },
            [_vm._t("main")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c(
            "div",
            {
              staticClass: "BaseDialog_Footer",
              attrs: { "data-test": "footerSlot" }
            },
            [_vm._t("footer")],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }